const apiBaseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:8787').replace(
  /\/$/,
  ''
);

export function getApiUrl(pathname) {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${apiBaseUrl}${normalizedPath}`;
}
